'use strict';

var React = require('react');

var SvgCashYenMajor = function SvgCashYenMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20 10c0-5.514-4.486-10-10-10s-10 4.486-10 10 4.486 10 10 10 10-4.486 10-10zm-9.025 1.754h1.25a.75.75 0 1 1 0 1.5h-1.25v1a1 1 0 0 1-2 0v-1h-1.25a.75.75 0 1 1 0-1.5h1.25v-.75h-1.25a.75.75 0 1 1 0-1.5h.859l-1.85-3.204a1 1 0 0 1 1.732-1l1.515 2.624 1.515-2.624a1 1 0 0 1 1.732 1l-1.85 3.204h.847a.75.75 0 1 1 0 1.5h-1.25v.75z"
  }));
};

exports.SvgCashYenMajor = SvgCashYenMajor;
